import React from 'react';
import { VenueSummary } from 'js/components/MapPopup/VenueSummary';
import { Popup } from 'js/components/Popup/Popup';
import * as track from 'js/components/MapPopup/tracking';
import { MapVenue } from 'js/model/view/map-view/MapVenue';
import { VenueRating } from 'js/model/rainbow/venue/VenueOutput';
import { choiceFormatter } from 'js/helpers/choice-formatter';
import { MapPopup } from 'js/pages/BrowsePage/MapView/MapPopup';
import styles from './BrowseMapPopup.module.css';
import { IconButtonsControl } from '../IconButtonsControl';
import { Context } from '../LocaleWrapper';

const assetClose = require('assets/images/map-close-hover.svg');

interface Props {
  mapCenter: {
    zoom: number;
  };
  name: string;
  rating: VenueRating;
  reviewCountText: string;
  addressLines: string[];
  mapVenue: MapVenue;

  goToVenueCta?: {
    label: string;
    url: string;
    onClick: (event: React.MouseEvent) => void;
    venueId: string;
  };

  trackEventCategory: string;

  onMapPopupCloseRequest: () => void;
}

export class BrowseMapPopup extends React.PureComponent<Props> {
  static contextType = Context;

  declare context: React.ContextType<typeof Context>;

  private mapZoom = this.props.mapCenter.zoom.toString();

  public componentDidMount(): void {
    track.open(this.props.trackEventCategory);
  }

  private onCloseRequest = (): void => {
    track.close(this.props.trackEventCategory, this.mapZoom);
    this.props.onMapPopupCloseRequest();
  };

  public render(): React.ReactNode {
    const reviewCountText = choiceFormatter(
      this.props.reviewCountText,
      this.props.rating.count
    );

    return (
      <Popup width={-100} height={-100} onCloseRequest={this.onCloseRequest}>
        <div className={styles.popupContainer}>
          <div className={styles.map}>
            <MapPopup
              venue={this.props.mapVenue}
              channel={this.context.channel}
              zoom={this.props.mapCenter.zoom}
            />
          </div>
          <div className={styles.descriptionContainer}>
            <VenueSummary
              name={this.props.name}
              address={this.props.addressLines}
              rating={this.props.rating.displayAverage}
              reviewCountText={reviewCountText}
              goToVenueCta={this.props.goToVenueCta}
            />
          </div>
          <IconButtonsControl
            positioningClassName={styles.closeControl}
            buttons={[{ iconUrl: assetClose, onClick: this.onCloseRequest }]}
          />
        </div>
      </Popup>
    );
  }
}

BrowseMapPopup.contextType = Context;
